import {
	SET_LIVE_TXN_FILTERS,
	SET_DASHBOARD_DATE_RANGE,
	GET_CHIMERA_CONFIG,
	SET_SELECTED_MERCHANTS,
	SET_TXN_PAYMENT_INSTRUMENTS,
} from './types';

export const setLiveTxnFilters = (payload) => ({
	type: SET_LIVE_TXN_FILTERS,
	payload,
});
export const setTxnPaymentInstruments = (payload) => ({
	type: SET_TXN_PAYMENT_INSTRUMENTS,
	payload,
});
export const setSelectedMerchants = (payload) => ({
	type: SET_SELECTED_MERCHANTS,
	payload,
});
export const setDashboardDateRange = (payload) => ({
	type: SET_DASHBOARD_DATE_RANGE,
	payload,
});
export const getChimeraConfig = (payload) => ({
	type: GET_CHIMERA_CONFIG,
	payload,
});
